import { Injectable,EventEmitter } from '@angular/core';
//import { Http, Response } from '@angular/http';
import { HttpClient ,HttpHeaders} from '@angular/common/http';

import { LoadingService } from './loading.service';
import { Config } from '../../../assets/configuration/config';
import { ThrowStmt } from '@angular/compiler';
declare var jslib:any; //呼叫第三方js
declare var $:any;
@Injectable()

export class ApiService {

  public eventUpdated:EventEmitter<object> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private loading: LoadingService
  ) { }

  public baseUrl = (Config.DebugMode) ? Config.localUrl : Config.releaseUrl;
  apiGet(url:string,param:any){
    this.loading.setLoading(true);
    var body = (param) ? param : {};
   
    body = Object.assign(body,{})
    ////console.log('[api Resquest]',url,body);
    
    return new Promise((resolve,reject)=>{
        var _url = this.baseUrl + url + jslib.ObjToParam(body);
        //console.log('[api Get] ObjToParam',body,jslib.ObjToParam(body));
        var headers = new HttpHeaders();
        if(Config.DebugLogin != ''){
          headers = new HttpHeaders().set('user', Config.DebugLogin);
        }
        this.http.get(_url,{headers:headers}).toPromise().then(
          (res : Response) => {
            //console.log('[api Get]',_url,res);

            this.loading.setLoading(false);
            if(res['statusCode'] == 200){

              //驗證User是否登入
              var _u = res['user'];
              if(_u){
                jslib.SetStorage('user',_u);
                this.eventUpdated.emit(_u);
              }else{
                this.eventUpdated.emit(null);
                jslib.SetStorage('user',null);
              }
              //申請報名特殊處理
              if(_url.indexOf('v1/buyer/columns/') > -1){
                if(res['data'] == null && res['errorMessage']){
                  resolve(res['errorMessage']);
                }else{
                  resolve(res['data']);
                }
              }
              //另外處理pager
              if(res['currentPage']){
                var pager = {
                  currentPage:res['currentPage'],
                  pageSize:res['pageSize'],
                  totalPage:res['totalPage'],
                  totalRows:res['totalRows']
                }
                res['data'] = {
                  pager:pager,
                  data:res['data']
                };
                resolve(res['data']);
              }else{
                resolve(res['data']);
              }
            }else{
              if(res['statusCode'] == 401){
                this.loading.setConfirm({
                  content:res['errorMessage'],
                  cancelTxt:'取消',
                  checkTxt:'前往登入',
                  event:()=>{
                    this.RedirectSSO();
                  }
                });
                reject(res);
              }else{
                var _error = {
                  url:res['url'],
                  status:res['status'],
                  errormsg:res['errorMessage']
                };
                this.loading.setConfirm(res['errorMessage']);
                reject(res);
              }
              
            }
          },
          (error: Response) => {
            this.loading.setLoading(false);
            if(error['status'] != 200){
              var _error = {
                url:error['url'],
                status:error['status'],
                errormsg:error['errorMessage']
              }
              //console.log('[API Error]',_error);
              reject(_error);
            }else{
              reject(error.json());
            }
          }
        );
    });
    
  }

  apiPut(url:string,param:any){
    this.loading.setLoading(true);
    var body = (param) ? param : {};
   
    body = Object.assign(body,{})
    ////console.log('[api Resquest]',url,body);
    
    return new Promise((resolve,reject)=>{
        var _url = this.baseUrl + url + jslib.ObjToParam(body);
        //for test
        var headers = new HttpHeaders();
        if(Config.DebugLogin != ''){
          headers = new HttpHeaders().set('user', Config.DebugLogin);
        }
        this.http.put(_url,body,{headers:headers}).toPromise().then(
          (res : Response) => {
            //console.log('baseapi put',res);

            this.loading.setLoading(false);
            if(res['statusCode'] == 200){

              //驗證User是否登入
              var _u = res['user'];
              if(_u){
                this.eventUpdated.emit(_u);
                jslib.SetStorage('user',_u);
              }else{
                this.eventUpdated.emit(null);
                jslib.SetStorage('user',null);
              }

              //另外處理pager
              if(res['currentPage']){
                var pager = {
                  currentPage:res['currentPage'],
                  pageSize:res['pageSize'],
                  totalPage:res['totalPage'],
                  totalRows:res['totalRows']
                }
                res['data'] = {
                  pager:pager,
                  data:res['data']
                };
                resolve(res['data']);
              }else{
                resolve(res['data']);
              }
            }else{
              var _error = {
                url:res['url'],
                status:res['status'],
                errormsg:res['errorMessage']
              };
              this.loading.setConfirm(res['errorMessage']);
              reject(res);
            }
          },
          (error: Response) => {
            this.loading.setLoading(false);
            if(error['status'] != 200){
              var _error = {
                url:error['url'],
                status:error['status'],
                errormsg:error['errorMessage']
              }
              //console.log('[API Error]',_error);
              reject(_error);
            }else{
              reject(error.json());
            }
          }
        );
    });
  }
 
  apiPost(url:string,param:any,ignoreLoading = false){
    if(!ignoreLoading){
      this.loading.setLoading(true);
    }
    
    var body = (param) ? param : {};
   
    body = Object.assign(body,{})
    ////console.log('[api Resquest]',url,body);
    
    return new Promise((resolve,reject)=>{
        var _url = this.baseUrl + url;
        //for test
        var headers = new HttpHeaders();
        if(Config.DebugLogin != ''){
          headers = new HttpHeaders().set('user', Config.DebugLogin);
        }
        this.http.post(_url,body,{headers:headers}).toPromise().then(
          (res : Response) => {
            //console.log('baseapi put',res);
            if(!ignoreLoading){
              this.loading.setLoading(false);
            }
            
            if(res['statusCode'] == 200){

              //驗證User是否登入
              var _u = res['user'];
              if(_u){
                this.eventUpdated.emit(_u);
                jslib.SetStorage('user',_u);
              }else{
                this.eventUpdated.emit(null);
                jslib.SetStorage('user',null);
              }

              //另外處理pager
              if(res['currentPage']){
                var pager = {
                  currentPage:res['currentPage'],
                  pageSize:res['pageSize'],
                  totalPage:res['totalPage'],
                  totalRows:res['totalRows']
                }
                res['data'] = {
                  pager:pager,
                  data:res['data']
                };
                resolve(res['data']);
              }else{
                resolve(res['data']);
              }
            }else{
              var _error = {
                url:res['url'],
                status:res['status'],
                errormsg:res['errorMessage']
              };
              this.loading.setConfirm(res['errorMessage']);
              reject(res);
            }
          },
          (error: Response) => {
            if(!ignoreLoading){
              this.loading.setLoading(false);
            }
            if(error['status'] != 200){
              var _error = {
                url:error['url'],
                status:error['status'],
                errormsg:error['errorMessage']
              }
              //console.log('[API Error]',_error);
              reject(_error);
            }else{
              reject(error.json());
            }
          }
        );
    });
  }
  
  // apiPostFile(url,File:File){
  //   var _url = this.baseUrl + url;
  //   this.loading.setLoading(true);
  //   const formData: FormData = new FormData();
  //   formData.append('file',File);
  //   return new Promise((resolve,reject)=>{
  //     this.http
  //       .post(_url, formData
  //     ).toPromise().then(
  //       (res)=>{
  //         this.loading.setLoading(false);
  //         resolve(res);
  //       },(error)=>{
  //         this.loading.setLoading(false);
  //         reject(error);
  //       }
  //     )
  //   });
  // }
  HashHandel(){
    //console.log('HashHandel');
    var hash = window.location.hash;
    if(hash != ''){
      setTimeout(()=>{
        var _scrollTo = $(hash);
        if(_scrollTo){
          $('html, body').animate({
            scrollTop: _scrollTo.offset().top
          }, 0);
        }
      },500);
    }
  }
  IsLogin(){
    var d = jslib.GetStorage('user');
    if(d && d != null){
      return true;
    }else{
      return false;
    }
  }
  GetUser(){
    var u = jslib.GetStorage('user');
    return u;
  }
  RedirectSSO(){
    //這邊需處理無窮迴圈問題
    var nowUrl = window.location.href;
    var root = window.location.origin;
    var redirectUrl = nowUrl.replace(root,'');
    var tempUrl = jslib.GetStorage('tempUrl',tempUrl);
    if(tempUrl){
      redirectUrl = tempUrl;
      jslib.SetStorage('tempUrl',null);
    }
    var redirect = Config.rootUrl + 'member/login?redirect=' + redirectUrl;
    window.location.href = redirect;
  }
  SSOLogout(){
    var nowUrl = window.location.href;
    var root = window.location.origin;
    var redirect = Config.rootUrl + 'member/logout?redirect=/home';
    window.location.href = redirect;
  }
}
